import { SET_EXPERIMENT_VARIANT } from 'root/src/client/logic/app/actionIds'

export default experimentVariant => ({
	type: SET_EXPERIMENT_VARIANT,
	payload: experimentVariant,
})
